export default __webpack_public_path__ + "static/media/PPI-firefeature-016.2b08521d.jpg";